import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const IndustryRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/industries'),
});